export default __webpack_public_path__ + "static/individuals-3-3501acf982a9d326bbe4633acd4093e2.jpg";